import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { environment } from 'src/environments/environment';
import { Endpoints } from '../enums/endpoints.enums';
import { IResponse } from '../interfaces/response.interface';
import { IResponseAuth } from '../interfaces/responseAuth.interface';
import { map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SecurityService {


  constructor(
    private httpService: HttpService,
    private httpClient: HttpClient
  ) {}

  getProfile(){
    const url = environment.apiUrl + Endpoints.GET_PROFILE;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.get<IResponseAuth>(url, options); 
  }

  login(request:any){
    const url = environment.apiUrl + Endpoints.LOGIN;
    const options = this.httpService.headerOptionsJson(false, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  logout(){
    const url = environment.apiUrl + Endpoints.LOGOUT;
    const options = this.httpService.headerOptionsJson(true, true);
    return this.httpClient.post<IResponseAuth>(url, null, options);
  }

  sendLink(request:any){
    const url = environment.apiUrl + Endpoints.SEND_LINK;
    const options = this.httpService.headerOptionsJson(false, false);
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  updatePassword(request:any, token: string){
    const url = environment.apiUrl + Endpoints.CHANGE_PASSWORD;
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    headers = headers.set("token",token);
    const options = { headers: headers};
    return this.httpClient.post<IResponseAuth>(url, request, options);
  }

  getMenu(token: string){
    const url = environment.apiUrl + Endpoints.GET_MENU;
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    headers = headers.set("token",token);
    const options = { headers: headers};
    return this.httpClient.get<IResponseAuth>(url, options).pipe(
      map(response => ({
        ...response,
        result: response.result.map((item: any) => ({
          id: item.id,
          name: item.nombre,
          url: item.ruta,
          icon: item.icono
        }))
      }))
    )
  }
}
